var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"editor"},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editor",staticClass:"text"})])}
var staticRenderFns = []

export { render, staticRenderFns }